module.exports = __webpack_public_path__ + "static/media/default-7.6acc0953.svg";